import _ from 'lodash';
import React from 'react';
import { WppListItem, WppMenuContext } from 'buildingBlocks';
import { Flight } from 'utils/types';
import { options } from 'containers/StrategyAnalytics/constants/strategyAnalyticsConstants';

type FlightContextMenuProps = {
  flights: { [key: string]: Flight } | Array<Flight>
  isSelected: string
  onClick: Function
  actionType: string
  type: string
};

const FlightContextMenu: React.FC<FlightContextMenuProps> = ({ flights, onClick, isSelected, type, actionType }: FlightContextMenuProps): React.ReactElement => (
  <WppMenuContext>
    <WppListItem slot="trigger-element" isExtended active={_.isEqual(isSelected, options.byObject[type].value)}>
      <p slot="label">{options.byObject[type].text}</p>
    </WppListItem>
    <div>
      {_.map(flights, ({ externalId, name }: Flight) => (
        <WppListItem key={externalId} value={externalId} onWppChangeListItem={() => onClick(actionType, externalId)}>
          <p slot="label">{name}</p>
        </WppListItem>
      ))}
    </div>
  </WppMenuContext>
);

export default FlightContextMenu;
